// Datas no horário de Brasília.
// O orçamento gravava a data de criação como "2026-10-26T00:00:00.000Z" (meia-noite em UTC), que a tela
// convertia para 25/10 21:00. Agora o servidor grava "2026-10-26T11:05:00" (Brasília, sem fuso).

const FUSO = 'America/Sao_Paulo';

// Hoje em Brasília no formato do input date (yyyy-mm-dd)
export function hojeBrasilia() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: FUSO, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
}

// { data: '26/10/2026', hora: '11:05' } de um texto gravado no banco
export function partesDataHora(valor) {
  if (!valor || valor === '-') return { data: '-', hora: '' };
  const texto = String(valor).trim();
  const m = texto.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return { data: texto, hora: '' };
  const [, ano, mes, dia, hh, mm] = m;
  const temFuso = /(Z|[+-]\d{2}:?\d{2})$/.test(texto);

  // Gravado em UTC
  if (temFuso) {
    // Meia-noite UTC = só a data escolhida (registros antigos): mostra a data, sem hora
    if ((hh === undefined || (hh === '00' && mm === '00'))) return { data: `${dia}/${mes}/${ano}`, hora: '' };
    const d = new Date(texto);
    if (isNaN(d)) return { data: `${dia}/${mes}/${ano}`, hora: '' };
    return {
      data: d.toLocaleDateString('pt-BR', { timeZone: FUSO }),
      hora: d.toLocaleTimeString('pt-BR', { timeZone: FUSO, hour: '2-digit', minute: '2-digit' })
    };
  }

  // Sem fuso: já é horário de Brasília, mostra como está
  return { data: `${dia}/${mes}/${ano}`, hora: hh !== undefined ? `${hh}:${mm}` : '' };
}
